import { AxiosPromise } from 'axios';
import axios from 'axios';
import {
  IGetCourses,
  IGetClass,
  IGetClasses,
  IClassReq,
  IClassTimeReq,
  IGetTransferableClasses,
  IRetireReq,
  IGetAllClasses,
  IStudentClassReq,
  IGetStudentClass,
  IClassAssignmentQuery,
  IGetClassAssignment,
  IGetAbsenceRefunds,
  IGetAbsenceRefund,
  IGetLastClassDate,
  IGetClassStudentPoints,
  IGetClass2,
  IClassReq2,
  IClassInfoReq2,
  IClassSubjectReq,
} from '../models/campusClasses.model';
import QueryString from 'qs';
import { IElearningParams, IGetElearning, IElearningBadWordParams, IGetElearningBadWordSummary, IGetElearningBadWord } from '../models/eLearning.model';
import _ from 'lodash';

const uri = '/mgmt/campus-classes';

export const saveRetireTodo = (
  classStudentCode: string,
  data: IRetireReq,
): AxiosPromise => {
  return axios.post(`${uri}/classes-retire/${classStudentCode}/todo`, data);
};

export const cancelRetireTodo = (classRetireCode: number): AxiosPromise => {
  return axios.put(`${uri}/classes-retire-cancel/${classRetireCode}/todo`);
};

// 환불할 인정결석 목록
export const getAbsenceRefunds = (
  classStudentCode: string,
): AxiosPromise<IGetAbsenceRefunds> => {
  return axios.get(`${uri}/classes/${classStudentCode}/refund`);
};

// 인정결석 환불정보 조회
export const getAbsenceRefund = (
  attendCode: number,
): AxiosPromise<IGetAbsenceRefund> => {
  return axios.get(`${uri}/classes/${attendCode}/single-refund`);
};

// 전반 전 수강반 마지막 수업일 조회
export const getLastClassDate = (
  classCode: string,
): AxiosPromise<IGetLastClassDate> => {
  return axios.get(`${uri}/class-move/${classCode}/time`);
};

// 전반
export const transferClass = (
  classCode: string,
  classStudentCode: string,
  data: {
    timetableCode: number | null | undefined;
  },
): AxiosPromise => {
  return axios.post(`${uri}/class-move/${classCode}/${classStudentCode}`, data);
};

// 폐강
export const closeClass = (data: { classCode: string }): AxiosPromise => {
  return axios.put(`${uri}/classes-cancel`, data);
};

// 수강반 내 학생 포인트
export const getClassStudentPoints = (
  classCode: string,
): AxiosPromise<IGetClassStudentPoints> => {
  return axios.get(`${uri}/students-point/${classCode}`);
};

// legacy

export const getCourses = (semesterCode: string): AxiosPromise<IGetCourses> => {
  return axios.get(`${uri}/campus/${semesterCode}/semester-courses`);
};

export const getCoursesInSemester = (semesterCode: string): AxiosPromise<IGetCourses> => {
  return axios.get(`${uri}/campus/${semesterCode}/semester-courses2`);
};

export const getClass = (classCode: string): AxiosPromise<IGetClass> => {
  return axios.get(`${uri}/${classCode}/detail`);
};

export const getClass2 = (classCode: string): AxiosPromise<IGetClass2> =>
  axios.get(`${uri}/${classCode}/detail2`);

export const getClasses = (
  campusCode: string,
  semesterCode: number,
): AxiosPromise<IGetClasses> => {
  return axios.get(`${uri}/${campusCode}/${semesterCode}`);
};

export const getAllClasses = (
  campusCode: string,
): AxiosPromise<IGetAllClasses> => {
  return axios.get(`${uri}/${campusCode}`);
};

export const getAllSemesterClasses = (
  campusCode: string,
  semesterCode: number,
): AxiosPromise<IGetAllClasses> => {
  return axios.get(`${uri}/${campusCode}/${semesterCode}`);
};

// 전반 가능한 학급 조회
export const getTransferableClasses = (
  classCode: string,
): AxiosPromise<IGetTransferableClasses> => {
  return axios.get(`${uri}/class-move/${classCode}`);
};

// 학생 퇴원
export const retire = (
  classStudentCode: string,
  data: IRetireReq,
): AxiosPromise => {
  return axios.post(`${uri}/classes-retire/${classStudentCode}`, data);
};

// 퇴원 취소
export const cancelRetire = (classRetireCode: number): AxiosPromise => {
  return axios.put(`${uri}/classes-retire-cancel/${classRetireCode}`);
};

export const createClass = (
  campusCode: string,
  data: IClassReq,
): AxiosPromise => {
  return axios.post(`${uri}/${campusCode}`, data);
};

export const createTimetable = (classCode: string): AxiosPromise => {
  return axios.post(`${uri}/${classCode}/timetables`);
};

export const updateClass = (
  classCode: string,
  data: IClassReq,
): AxiosPromise => {
  return axios.put(`${uri}/${classCode}`, data);
};

export const updateClassInfo = (
  classCode: string,
  data: IClassReq,
): AxiosPromise => {
  return axios.put(`${uri}/class-info/${classCode}`, data);
};

export const updateClassTime = (
  classTimeCode: number,
  data: IClassTimeReq,
): AxiosPromise => {
  return axios.put(`${uri}/class-time/${classTimeCode}`, data);
};

export const updateTeacher = (id: string, data: any): AxiosPromise => {
  return axios.put(`${uri}/${id}/className`, data);
};

export const deleteClass = (classCode: string): AxiosPromise => {
  return axios.delete(`${uri}/${classCode}`);
};

// 학생의 특정일 기준 학급 조회
export const getStudentClassByDate = (
  params: IStudentClassReq,
): AxiosPromise<IGetStudentClass> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/classes-information?${qsParams}`);
};

export const getClassesAssignment = (
  campusCode: string,
  params?: IClassAssignmentQuery,
): AxiosPromise<IGetClassAssignment> =>
  axios.get(`${uri}/${campusCode}/assignment`, { params });

export const createClass2 = (
  campusCode: string,
  req: IClassReq,
): AxiosPromise => {
  return axios.post(`${uri}/${campusCode}/2`, req);
};

export const updateClassInfo2 = (
  classCode: string,
  req: IClassInfoReq2[],
): AxiosPromise => {
  return axios.put(`${uri}/class-info/${classCode}/2`, req);
};

export const updateClass2 = (
  classCode: string,
  data: IClassReq2,
): AxiosPromise => {
  return axios.put(`${uri}/${classCode}/2`, data);
};

export const updateClassSubject = (
  classCode: string,
  body: IClassSubjectReq[],
) => axios.put(`${uri}/class-subject/${classCode}`, body);

export const getClassElearning = (params?:IElearningParams): AxiosPromise<IGetElearning> => {
  return axios.get(`${uri}/class-elearning`, {params});
};

// CANBot 욕설 채팅
export const getClassElearningBadWord = (params: IElearningParams): AxiosPromise<IGetElearningBadWord> => {
  const safeParams = _.pickBy(params, _.identity);
  const qsParams = QueryString.stringify(safeParams);
  return axios.get(`${uri}/class-elearning-bad-word?${qsParams}`);
};

// CANBot 욕설 
export const getClassElearningBadWordsummary = (params: IElearningParams): AxiosPromise<IGetElearning> => {
  const safeParams = _.pickBy(params, _.identity);
  const qsParams = QueryString.stringify(safeParams);
  return axios.get(`${uri}/class-elearning-bad-word-summary?${qsParams}`);
};

// 학급 학기 일괄 수료(특강반)
export const graduateClass = (data: { classCode: string }): AxiosPromise => {
  return axios.put(`${uri}/graduate-class`, data);
};